import { SettingsActionTypes } from './types';
import { action } from 'typesafe-actions';

export const unlinkDBYDStart = (payload: any) =>
  action(SettingsActionTypes.UNLINK_DBYD_START, payload);
export const unlinkDBYDSuccess = (payload: any) =>
  action(SettingsActionTypes.UNLINK_DBYD_SUCCESS, payload);
export const unlinkDBYDFailure = (error: string) =>
  action(SettingsActionTypes.UNLINK_DBYD_FAILURE, error);

export const updateUserPreferencesStart = (payload: any) =>
  action(SettingsActionTypes.UPDATE_USER_PREFERENCES_START, payload);
export const updateUserPreferencesSuccess = (payload: any) =>
  action(SettingsActionTypes.UPDATE_USER_PREFERENCES_SUCCESS, payload);
export const updateUserPreferencesFailure = (error: string) =>
  action(SettingsActionTypes.UPDATE_USER_PREFERENCES_FAILURE, error);

export const updateConfigurationStart = (payload: any) =>
  action(SettingsActionTypes.UPDATE_CONFIGURATION_START, payload);
export const updateConfigurationSuccess = (payload: any) =>
  action(SettingsActionTypes.UPDATE_CONFIGURATION_SUCCESS, payload);
export const updateConfigurationFailure = (error: string) =>
  action(SettingsActionTypes.UPDATE_CONFIGURATION_FAILURE, error);

export const invalidatePermalinkStart = () =>
  action(SettingsActionTypes.INVALIDATE_PERMALINK_START);
export const invalidatePermalinkSuccess = () =>
  action(SettingsActionTypes.INVALIDATE_PERMALINK_SUCCESS);
export const invalidatePermalinkFailure = (error: string) =>
  action(SettingsActionTypes.INVALIDATE_PERMALINK_FAILURE, error);

export const setEmailLinkingStart = (payload: any) =>
  action(SettingsActionTypes.SET_EMAIL_LINKING_START, payload);
export const setEmailLinkingSuccess = (payload: any) =>
  action(SettingsActionTypes.SET_EMAIL_LINKING_SUCCESS, payload);
export const setEmailLinkingFailure = (error: string) =>
  action(SettingsActionTypes.SET_EMAIL_LINKING_FAILURE, error);
